module.exports = __webpack_public_path__ + "static/img/e7.4fa88f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/e7.png
// module id = PG5+
// module chunks = 1